<template>
  <div>
    <div class="clients" :class="{'darkMode' : state.darkMode}">
      <div class="w3-container">
        <div class="headerGrid">
          <div>
            <header>
              <h2>Add Product</h2>
            </header>
          </div>
          <div>
            <router-link to="/products" class="w3-button w3-red w3-small w3-right vmiddle">
              <i class="fas fa-times" style="margin-right:8px"></i>Cancel
            </router-link>
            <button @click="saveProduct()" class="w3-button w3-green w3-small w3-right vmiddle" style="margin-right:8px">
              <i class="fas fa-save" style="margin-right:8px"></i>Save
            </button>
          </div>
        </div>

        <div class="w3-row-padding w3-section">
          <div class="outline">
            <header class="w3-container dark">
              <h5>Product Details</h5>
            </header>
            <div class="cardBody">
              <div class="w3-row-padding w3-padding-v">
                <div class="w3-col w3-half">
                  <label for="name">Product Name</label>
                  <input class="w3-input w3-border" type="text" name="name" placeholder="Product Name" v-model="newProduct.name" :class="{'w3-border-red': nameError}">
                </div>
                <div class="w3-col w3-half">
                  <label for="type">Choose Type</label>
                  <select class="w3-input w3-border" type="text" name="type" v-model="newProduct.type">
                    <option value="choose">Choose Type</option>
                    <option value="service">Subscription</option>
                    <option value="good">Single Charge</option>
                  </select>
                </div>
              </div>

              <!-- <div class="w3-row-padding w3-padding-v" v-if="newProduct.type == 'service'">
                <div class="w3-col w3-third">
                  <label for="type">Plan Name</label>
                  <input class="w3-input w3-border" type="text" placeholder="Plan Name" v-model="newPlan.name">
                </div>
                <div class="w3-col w3-third">
                  <label for="type">Plan Interval</label>
                  <select class="w3-input w3-border" type="text" v-model="newPlan.interval">
                    <option value="day">Day</option>
                    <option value="week">Week</option>
                    <option value="month">Month</option>
                    <option value="year">Year</option>
                  </select>
                </div>
                <div class="w3-col w3-third">
                  <label for="type">Plan Amount</label>
                  <money class="w3-input w3-border" v-model="newPlan.amount" v-bind="money" @keydown.enter="saveProduct()"></money>
                </div>
              </div> -->

              <!-- <template class="w3-row-padding w3-padding-bottom" v-for="(value, propertyName, index) in newClient">
                <div class="w3-row-padding w3-padding-bottom" :key="index" v-if="value == ''">
                  <span class="w3-text-red" style="text-transform:capitalize">{{propertyName}} required</span>
                </div>
              </template> -->

              <div class="w3-row-padding w3-padding-bottom">
                <div class="w3-col">
                  <router-link to="/products" class="w3-button w3-red w3-small w3-right" style="margin-top:15px">
                    <i class="fas fa-times" style="margin-right:8px"></i>Cancel
                  </router-link>
                  <button @click="saveProduct()" class="w3-button w3-green w3-small w3-right" style="margin-top:15px; margin-right:8px">
                    <i class="fas fa-save" style="margin-right:8px"></i>Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import dataStore from '../dataStore'

export default {
  name: "addProduct",
  data() {
    return {
      state: dataStore.state,
      newProduct: {
        name: '',
        type: 'choose'
      },
      // newPlan: {
      //   name: '',
      //   currency: 'USD',
      //   interval: 'month', // day, week, month, year
      //   product: '', // product id
      //   amount: 0
      // },
      nameError: false
    }
  },
  methods: {
    saveProduct() {
      this.nameError = false
      if ((this.newProduct.name || this.newProduct.type) == (undefined || '' || null)) {
        this.nameError = true
        return
      } else {
        dataStore.saveProduct(this.newProduct).then(product => {
          dataStore.getAdminGlobalData()
          this.$router.replace('/products')
        })
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/addProduct.vue